export default __webpack_public_path__ + "static/media/AdobeFnt21.b03cc0f2.lst";